// Exports
export default {
	"accountWrapper": "accountWrapper_mJOgc",
	"accountSettingsWrapper": "accountSettingsWrapper_zuOoW",
	"header": "header_IM2wK",
	"info": "info_9jTsb"
};
